import { NeoModel, ModelBase } from "@singularsystems/neo-core";

@NeoModel
export default class OrganisationSettingSearchCriteria extends ModelBase {
    public organisationName: string = "";

    public attribute: string = "";

    public value: string = "";
}